import { Base } from '../base-component';
import './filter-builder.component.scss';

import * as $ from 'jquery';

export class FilterBuilder extends Base {

	constructor(element: Element){

		super(element);

	}

	// components
	form: any;
	selectButtons: any;
	selectItems: any;
	clearButton: any;
	clearButtonInput: any;
	searchBars: any;
	multpleSelected: any;
	multpleSelectedLabel: any;
	checkboxesDesktop: any;
	activeDropdown: any;

	init(){

		this.form = this.element.querySelector('#filter-builder-form');
		this.selectButtons = Array.from(this.element.querySelectorAll('.filter-builder__form-field--select-button'));
		this.selectItems = Array.from(this.element.querySelectorAll('.filter-builder__form-field--select-box-item'));
		this.searchBars = Array.from(this.element.querySelectorAll('.js-search-bar'));
		this.clearButton = this.element.querySelector('.js-clear-filters');
		this.clearButtonInput = this.element.querySelector('.filter-builder__form-field--searchbuttonclear');
		this.multpleSelected = Array.from(this.element.querySelectorAll('.filter-builder__form-field--select-box-item input'));
		this.multpleSelectedLabel = this.element.querySelector('.js-checkbox-multiple-only');
		this.checkboxesDesktop = Array.from(this.element.querySelectorAll('.filter-builder__form-field--checkboxlabel input'));

		setTimeout(() => {
			this.removeDropDownItem();
			this.changeButtonText();
		}, 500);

	}

	bindEvents() {

		if(this.form) {
			this.form.addEventListener('click', (event)=>{
				let component =  event.target;
				if(component.classList.contains('title')) {
                    this.closeAllSelects();
				}
				if(component.classList.contains('col-12')) {
                    this.closeAllSelects();
				}
				if(component.classList.contains('filter-builder__form-field--hr')) {
                    this.closeAllSelects();
				}
			})
		}

		if(this.selectButtons){
			this.selectButtons.map((item) => item.addEventListener('click', (event) => {

				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}

				// if(element.classList.contains('filter-builder__form-field--select-button__active')) {
				// 	element.classList.remove('filter-builder__form-field--select-button__active');
				// }else{
				// 	element.classList.add('filter-builder__form-field--select-button__active');
				// }

				let parent = element.closest('.filter-builder__form-field--container');
				let box = parent.querySelector('.filter-builder__form-field--select-box');

				if(box.classList.contains('filter-builder__form-field--select-box-active')){
					box.classList.remove('filter-builder__form-field--select-box-active');
					element.classList.remove('filter-builder__form-field--select-button__active');
				}else{
					this.closeAllSelects();
					box.classList.add('filter-builder__form-field--select-box-active');
					element.classList.add('filter-builder__form-field--select-button__active');
				}
	
			}));
		}

		if(this.selectItems) {
			this.selectItems.map((item) => item.addEventListener('click', (event) => {
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}

				let value = element.getAttribute('data-value');
				let name = element.getAttribute('data-name');
				let parent = element.closest('.filter-builder__form-field--container');
				let button = parent.querySelector('.filter-builder__form-field--select-button');
				let box = parent.querySelector('.filter-builder__form-field--select-box');
	
				if(!button.classList.contains('js-checkbox-multiple-only')){
					let checkboxes = Array.from(box.querySelectorAll('input'));
					if(checkboxes.length > 0) {
						let amountChecked = 0;
						let checkedLabels = [];
						checkboxes.map((checkbox: any)=>{
							if(checkbox.checked){
								checkedLabels.push(checkbox.getAttribute('data-value'));
								amountChecked++;
							}
						});
						if(amountChecked > 1){
							button.innerHTML = amountChecked + ' Selected';
						}else if(amountChecked == 0){
							button.innerHTML = 'Please select';
						}else{
							if(checkedLabels[0]) {
								button.innerHTML = checkedLabels[0];
							}
						}
					}else{
						console.log('No Checkboxes');
						button.innerHTML = name;
					}
				}
				box.classList.toggle('filter-builder__form-field--select-box-active');
				button.classList.toggle('filter-builder__form-field--select-button__active');
	
			}));
		}

		if(this.clearButton) {
			this.clearButton.addEventListener('click', (event)=>{
				this.selectButtons.map((button)=>{
					button.innerHTML = 'Please select';
				})
				this.form.reset();
			});
		}

		$('body').on('click', 'a#resetSearch', (event)=>{
			this.selectButtons.map((button)=>{
				button.innerHTML = 'Please select';
			})
			this.form.reset();
		});

		if(this.clearButtonInput) {
			this.clearButtonInput.addEventListener('click', (event)=>{
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element.target;
				}
				let parent = element.closest('.filter-builder__form-field--container');
				let searchButton = parent.querySelector('.filter-builder__form-field--searchbutton');
				searchButton.classList.remove('active');
				element.classList.add('d-none');
				let inputs = Array.from(this.form.querySelectorAll('input'));
				inputs.map((input: any)=>{
					input.value = '';
				})
			});
		}

		if(this.multpleSelected) {
			this.multpleSelected.map((item) => item.addEventListener('click', (event) => {
				let amountChecked = 0;
				let checkedLabels = [];
				this.multpleSelected.map((checkbox)=>{
					if(checkbox.checked){
						checkedLabels.push(checkbox.getAttribute('data-value'));
						amountChecked++;
					}
				});
				if(this.multpleSelectedLabel){
					if(amountChecked > 1){
						this.multpleSelectedLabel.innerHTML = amountChecked + ' Selected';
					}else if(amountChecked == 0){
						this.multpleSelectedLabel.innerHTML = 'Please select';
					}else{
						if(checkedLabels[0]) {
							this.multpleSelectedLabel.innerHTML = checkedLabels[0];
						}
					}
				}
			}));
		}

		if(this.checkboxesDesktop) {
			this.checkboxesDesktop.map((item) => item.addEventListener('click', (event) => {
				this.closeAllSelects();
			}));
		}

		if(this.searchBars) {

			this.searchBars.map((searchbar)=>searchbar.addEventListener('focus', (event)=>{
				this.closeAllSelects();
			}));

			this.searchBars.map((searchbar)=>searchbar.addEventListener('keyup', (event)=>{
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
				let parent = element.closest('.filter-builder__form-field--container');
				let clearButton = parent.querySelector('.filter-builder__form-field--searchbuttonclear');
				let searchButton = parent.querySelector('.filter-builder__form-field--searchbutton');
				
				if(element.value.length > 0){
					clearButton.classList.remove('d-none');
					searchButton.classList.add('active');
				}else{
					clearButton.classList.add('d-none');
					searchButton.classList.remove('active');
				}

			}));
		}

	}

	removeDropDownItem() {

		if(this.selectItems) {
			this.selectItems.map((item)=>{
				if(item.classList.contains('dropdown-item')){
					item.classList.remove('dropdown--item');
				}
			})
		}

	}

	changeButtonText() {

		if(this.selectButtons) {

			this.selectButtons.map((button)=>{
				button.innerHTML = 'Please select';
			})

		}

	}

	closeAllSelects() {

		let allSelectButtons: any = Array.from(document.querySelectorAll('.filter-builder__form-field--select-button'));

		allSelectButtons.map((item) => {

			let element = item;
			let parent = element.closest('.filter-builder__form-field--container');
			let box = parent.querySelector('.filter-builder__form-field--select-box');
			element.classList.remove('filter-builder__form-field--select-button__active');
			box.classList.remove('filter-builder__form-field--select-box-active');

		});

	}

}


// WEBPACK FOOTER //
// ./components/filter-builder/filter-builder.component.ts